export enum CookieConsentPrivacy {
  CCPA = 'CCPA', // California Consumer Privacy Act
  GDPR = 'GDPR', // EU General Data Protection Regulation
  PIPEDA = 'PIPEDA' // Canada Personal Information Protection and Electronic Documents Act
}
